import React from 'react'
import Layout from '../layout/layout'
import { Row, Col } from 'react-bootstrap'
import styles from './staticpages.module.css'

const RefundPolicy: React.FC = () => {
  return (
    <Layout>
      <Row>
        <Col xl={8} className="mx-auto">
          <Row>
            <Col>
              <h1 className="pageTitle mb-4">Refund Policy</h1>
            </Col>
          </Row>
          <Row>
            <Col className={styles.staticPage}>
              <h5>
                <b>Returns</b>
              </h5>
              <p>
                If you are not fully satisfied with your purchase, you can
                return your undamaged device within 7 days after delivery for a
                full refund less handling fees. For Singapore, If you return the
                item in the same condition as you received it, only a S$25
                handling fee will be deducted and you will get your full refund
                within 14 days after we received and checked the item. For the
                Philippines, a handling fee of $100 will be deducted and you
                will get the full refund. Delivery costs for the return will be
                borne by the customers. If 7 days have gone by since your
                purchase, unfortunately we can’t offer you a refund or exchange.
                To be eligible for a return, your item must be unused and in the
                same condition that you received it. It must also be in the
                original packaging. In case that there are obvious signs of use,
                we will grant you no or partial refunds (depending on the signs
                of use).
              </p>
              <h5>
                <b>How do I return the device?</b>
              </h5>
              <p>
                To return your purchased devices at BigMochi, please send us an
                email with your name, address and the order number to&nbsp;
                <a href="mailto:store@bigmochi.com">store@bigmochi.com</a>{' '}
                within 7 days upon receipt of the device. If you fail to request
                within the specified period, the initiation of the return is not
                possible. The request will be reviewed and approved by our
                customer service team within 24 hours.
              </p>
              <h5>
                <b>Can I exchange the device instead?</b>
              </h5>
              <p>
                BigMochi also offers the option to exchange your received model
                for an alternative phone in case. If you want to exchange it for
                the same model or another item, send us an email to&nbsp;
                <a href="mailto:store@bigmochi.com">store@bigmochi.com</a>.
                Please note that in case of exchanges or replacements of your
                device, neither the return period nor the warranty period
                restarts.
              </p>
              <h5>
                <b>Shipping</b>
              </h5>
              <p>
                Once your request is approved, our customer service team will
                send you details where and how to return the device. You will be
                responsible for paying for your own shipping costs for returning
                your item. Shipping costs are non-refundable. If you are
                shipping an item over $75, you should consider using a trackable
                shipping service or purchasing shipping insurance. Otherwise we
                can't guarantee that we will receive your returned item.
              </p>
              <h5>
                <b>When will I get my refund?</b>
              </h5>
              <p>
                The refund process will only begin after we have completed
                evaluating your returned product and if it is deemed to be a
                valid return with no obvious signs of usage. You will be
                notified via email once your refund is being processed. The
                refund processing time period depends on the mode of the payment
                during the purchase of the device and normally takes a couple of
                days.
              </p>
              <h5>
                <b>What should I do in case of late or missing refunds?</b>
              </h5>
              <p>
                If your refund has been issued but does not show in your bank
                account after the next two months' statements, please contact
                your issuing bank directly for support first. If you still have
                not received your refunds, get in touch with us via email
                at&nbsp;
                <a href="mailto:store@bigmochi.com">store@bigmochi.com</a>.
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </Layout>
  )
}

export default RefundPolicy
